// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgEtcOnUnique24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				viewBox="0 0 37 29"
				fill="none"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M31.8037 2.52349H5.80371C4.36777 2.52349 3.20371 3.68759 3.20371 5.12349V23.3943C3.20371 24.8302 4.36777 25.9943 5.80371 25.9943H31.8037C33.2396 25.9943 34.4037 24.8302 34.4037 23.3943V5.12349C34.4037 3.68759 33.2396 2.52349 31.8037 2.52349ZM5.80371 0.123535C3.04229 0.123535 0.803711 2.36209 0.803711 5.12349V23.3943C0.803711 26.1557 3.04229 28.3943 5.80371 28.3943H31.8037C34.5651 28.3943 36.8037 26.1557 36.8037 23.3943V5.12349C36.8037 2.36209 34.5651 0.123535 31.8037 0.123535H5.80371Z"
					fill="#2E2F32"
				/>
				<path
					d="M31.0656 4.65869H6.5457C5.88296 4.65869 5.3457 5.19595 5.3457 5.85869V22.6587C5.3457 23.3214 5.88296 23.8587 6.5457 23.8587H31.0656C31.7283 23.8587 32.2656 23.3214 32.2656 22.6587V5.85869C32.2656 5.19595 31.7283 4.65869 31.0656 4.65869Z"
					fill="#2E2F32"
					fillOpacity={0.12}
				/>
			</Svg>
		);
	}
);
SvgEtcOnUnique24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgEtcOnUnique24;
